import {PlatformModule} from '@angular/cdk/platform';
import {NgModule} from '@angular/core';
import {DateAdapter as MaterialDateAdapter, MAT_DATE_FORMATS} from '@angular/material/core';
import {DateAdapter} from '@matheo/datepicker/core';
import {MAT_NATIVE_DATE_FORMATS} from '@matheo/datepicker/core';
import { CustomDateAdapter } from './custom-date-adapter';

export * from '@matheo/datepicker/core';


@NgModule({
  imports: [PlatformModule],
  providers: [
    {provide: DateAdapter, useClass: CustomDateAdapter},
    {provide: MaterialDateAdapter, useClass: CustomDateAdapter},
  ],
})
export class CustomNativeDateModule {}


@NgModule({
  imports: [CustomNativeDateModule],
  providers: [{provide: MAT_DATE_FORMATS, useValue: MAT_NATIVE_DATE_FORMATS}],
})
export class CustomMatNativeDateModule {}
